import { getManagedCredential } from "../auth-refresh-coordinator"
import { BACKEND_URI, fetchWithAuthRetry, getHeaders } from "./_shared"
export type AgentDeliveryReceipt = {
  id: string
  artifact_id: string
  artifact_version: number
  channel: "email" | "teams"
  destination_id: string
  destination_name: string
  state: string
  code: string | null
  content_included: boolean
  attempt_count: number
  updated_at: string
}
const base = (agentId: string) =>
  `${BACKEND_URI}/hosted-agents/${encodeURIComponent(agentId)}/deliveries`
export type AgentUndeliveredResult = {
  result_id: string
  run_id: string
  title: string
  artifact_id: string
  state: "pending_enqueue" | "cancelled"
  code: string | null
  recovery_attempts: number
  created_at: string
  updated_at: string
}
export type AgentDeliveryPage = {
  deliveries: AgentDeliveryReceipt[]
  undelivered_results?: AgentUndeliveredResult[]
  count: number
  truncated: boolean
  next_cursor: string | null
}
export async function listAgentDeliveries(
  agentId: string,
  options: { cursor?: string; limit?: number; signal?: AbortSignal } = {}
): Promise<AgentDeliveryPage> {
  const params = new URLSearchParams({ limit: String(options.limit ?? 50) })
  if (options.cursor) params.set("cursor", options.cursor)
  const response = await fetchWithAuthRetry(`${base(agentId)}?${params}`, {
    headers: getHeaders(getManagedCredential()),
    signal: options.signal,
  })
  return response.json()
}
export async function retryAgentDelivery(
  agentId: string,
  receiptId: string,
  acknowledge: boolean
): Promise<AgentDeliveryReceipt> {
  return (
    await fetchWithAuthRetry(`${base(agentId)}/${encodeURIComponent(receiptId)}/retry`, {
      method: "POST",
      headers: getHeaders(getManagedCredential()),
      body: JSON.stringify({ acknowledge_duplicate_risk: acknowledge }),
    })
  ).json()
}

export type AgentDeliveryOptions = {
  available_channels: ("email" | "teams")[]
  teams_destinations: { id: string; name: string }[]
}
export async function getAgentDeliveryOptions(agentId: string): Promise<AgentDeliveryOptions> {
  return (
    await fetchWithAuthRetry(
      `${BACKEND_URI}/hosted-agents/${encodeURIComponent(agentId)}/delivery-options`,
      { headers: getHeaders(getManagedCredential()) }
    )
  ).json()
}
